import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { Subscription } from 'rxjs';
import { getControl } from 'src/app/_helpers/utils';
import { COUNTRIES, getCountryName } from 'src/app/helpers/nationalities';

@Component({
  selector: 'app-shared-business-form',
  templateUrl: './shared-business-form.component.html',
  styleUrls: ['./shared-business-form.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatOptionModule,
    MatFormFieldModule,
    MatSelectModule,
  ],
})
export class SharedBusinessFormComponent
  implements OnInit, OnChanges, OnDestroy
{
  @Input()
  formGroup!: FormGroup;

  @Input()
  showStaffFields: boolean = true;

  @Input()
  showActivityFields: boolean = true;

  hasLaborAgreementSubscription!: Subscription;

  isInternationalSubscription!: Subscription;

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    // Handle conditional fields
    this.hasLaborAgreementSubscription = this.formGroup.controls[
      'hasLaborAgreement'
    ].valueChanges.subscribe((value) => {
      if (value !== 'true' && value !== true) {
        this.formGroup.controls['laborAgreement'].reset();
      }
    });

    this.isInternationalSubscription = this.formGroup.controls[
      'isInternational'
    ].valueChanges.subscribe((value) => {
      if (value !== 'true' && value !== true) {
        this.formGroup.controls['activityCountries'].reset();
      }
    });
  }

  ngOnChanges(): void {
    if (this.formGroup) {
      // Reset staff fields when hidden
      if (!this.showStaffFields) {
        this.formGroup.controls['collaboratorsCount']?.reset();
        this.formGroup.controls['yearlyAnnualRevenue']?.reset();
        this.formGroup.controls['yearlySalaries']?.reset();
      }

      // Reset activity fields when hidden
      if (!this.showActivityFields) {
        this.formGroup.controls['isInternational']?.reset();
        this.formGroup.controls['activityCountries']?.reset();
        this.formGroup.controls['hasSubcontractors']?.reset();
      }
    }
  }

  ngOnDestroy(): void {
    if (this.hasLaborAgreementSubscription) {
      this.hasLaborAgreementSubscription.unsubscribe();
    }
    if (this.isInternationalSubscription) {
      this.isInternationalSubscription.unsubscribe();
    }
  }

  countries = COUNTRIES;

  countriesISO = Object.keys(COUNTRIES);

  getCountryName(countryCode: string): string {
    return getCountryName(countryCode, 'fr') || countryCode;
  }

  getControl(control: AbstractControl): FormControl {
    return getControl(control);
  }
}
